import { Helmet } from 'react-helmet';

import React from 'react';

const DEMO_ACCOUNT_GUIDE_PAGE_URL = 'https://blog.naver.com/appifystudio/222850654117';
const DEMO_ACCOUNT_PAGE_URL = 'https://support.google.com/analytics/answer/6367342?hl=ko';
const UPDATE_URL = '/ga4/update';

export const PageDemo = () => {
  const deco = {fontSize: 18}

  return (
    <>
      <Helmet>
        <title>데모 계정 연동하기</title>
      </Helmet>
      <div>
        <h2>데모 계정 연동 방법 업데이트 안내</h2>
        <br/>
        <br/>
        <a href={DEMO_ACCOUNT_GUIDE_PAGE_URL} target="_blank">데모 계정 연동 방법 확인하기</a>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <p style={deco}><i>위 내용을 확인 후 데모 계정을 연동해주세요.</i></p>
        <a style={deco} href={DEMO_ACCOUNT_PAGE_URL} target="_blank"><i>데모 계정 연동하러 가기</i></a>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <p>구글 애널리틱스 업데이트 사항이 발견되면, 책의 내용을 업데이트하고 있습니다.</p>
        <p>업데이트 내역은 아래에서 확인할 수 있습니다.</p>
        <a href={UPDATE_URL} target="_blank">업데이트 내역 확인하기</a>
      </div>
    </>
  );
}